// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ab08e371","50":"fcf6d592","156":"fbe8f69c","185":"1d591725","200":"fd30ade6","241":"f59eea5e","423":"20925548","565":"6fd678aa","654":"293b3567","768":"f1dce226"}[chunkId] + ".chunk.js";
};